<template>
    <div>
        <div class="row">
            <h3 style="color: #84B329; padding-top: 20px;text-align: center;">
                ข้อมูลเห็ดของท่าน
            </h3>
        </div>
        <div class="row" style="margin-top: 20px;">
            <div class="col-md-6 form-inline">
                จำนวนเห็ดตามชื่อเห็ด :
                <br>
                <ul class="list-inline">
                    <li v-for="item in mushRoomByName" >
                        <p class="text-primary">
                            <span v-on:click="searchByClickName(item.mushroom_thai)"
                                  style="cursor: pointer;">
                                {{item.mushroom_thai}} ({{item.name_count}})
                            </span>
                            <router-link :to="`/editmushroom/${item.mushroom_data_id}`" class="dropdown-item">
                            <span  >
                            <icon name="pencil"
                                  style="color: gray;margin-top: 3px;padding-top: 2px;cursor: pointer"
                            >
                            </icon>
                            </span>
                            </router-link>
                        </p>

                    </li>
                </ul>
            </div>
            <div class="col-md-6 form-inline">
                จำนวนเห็ดตามประเภท :
                 <br>
                <ul class="list-inline">
                    <li v-for="item in mushRoomByType">
                        <p class="text-primary">{{item.mushroom_type}} ({{item.name_count}})</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;">
            <div class="col-md-12 form-inline">
                ค้นหา ประเภทเห็ด :
                <select v-model="mushroom_type"
                        class="form-control"
                        style="width: 120px;"
                >
                 <option value="all">ทั้งหมด</option>
                 <option value="unknown">ไม่ทราบ</option>
                 <option value="poison">เห็ดพิษ</option>
                 <option value="edible">เห็ดกินได้</option>
               </select>

                <input
                        ref="mushroom_name"
                        type="text"
                        class="form-control"
                        placeholder="ค้นตามชื่อเห็ด"
                        v-model="mushroom_search"
                        style="width: 250px"
                >
            </div>
            <div class="col-md-12 text-center">
                &nbsp;&nbsp;
                <p v-if="isLoading" class="form-inline">
                    <img src="../assets/loading.gif" width="32">
                </p>

                <p v-show="isSearchName">
                    ค้นหาพบ "<font color="red">{{mushroom_search}}</font>"
                    ประเภท {{getMushroomType}}
                    จำนวน {{uploadedFiles.length}} ภาพ
                </p>

            </div>
            <div class="col-md-12">
                <ul class="list-inline">
                    <li v-for="item in uploadedFiles">
                        <img
                                :src="item.url_file_thumbnail"
                                class="img-responsive img-thumbnail"
                                :alt="item.mushroom_thai"
                                style="cursor: pointer"
                                width="150px"
                        >
                        <p class="text-center">
                            {{item.mushroom_thai}}
                            <a href="#" v-on:click.prevent="removeMushroom(item)" >
                            <icon name="trash"
                                  style="color: red;margin-top: 3px;padding-top: 2px;cursor: pointer"
                            >
                            </icon>
                            </a>
                        </p>

                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

export default {
  data: function () {
    return {
      loading: false,
      uploadedFiles: [],
      mushRoomByName: [],
      mushRoomByType: [],
      mushroom_search: '',
      mushroom_type: 'all'
    }
  },
  created () {
    if (this.getAuthen.token === '') {
      window.location.replace('/')
      return
    }
    this.fetchData()
  },
  ready () {
    this.searchByMushroomName()
  },
  methods: {
    getUrlOwnMushRoom () {
      return this.getBaseUrl + '/ownmushroom.php'
    },
    getUrlOwnMushRoomSearch () {
      return this.getBaseUrl + '/ownmushroom_by_search.php'
    },
    getUrlRemoveMushRoom () {
      return this.getBaseUrl + '/remove_mushroom.php'
    },
    getUrlMushroomCountByName () {
      return this.getBaseUrl + '/ownmushroom_by_name.php'
    },
    getUrlMushroomCountByType () {
      return this.getBaseUrl + '/ownmushroom_by_type.php'
    },
    searchByClickName (name) {
      this.mushroom_search = name
      // console.log(name)
    },
    editMushroom (item) {
      console.log(item)
      // alert(item)
    },
    fetchData () {
      var that = this
      const formData = new FormData()
      formData.append('hph_id', this.getAuthen.hph_id)
      formData.append('token', this.getAuthen.token)
      this.loading = true
      axios.post(this.getUrlOwnMushRoom(), formData)
        .then(function (response) {
          var result = response.data
          // console.log(result)
          // alert(result)
          that.loading = false
          that.uploadedFiles = result
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response)
          }
        })
      // count by mushroom name
      axios.post(this.getUrlMushroomCountByName(), formData)
        .then(function (response) {
          var result = response.data
          // console.log(result)
          // alert(result)
          that.loading = false
          that.mushRoomByName = result
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response)
          }
        })
      // count by mushroom type
      axios.post(this.getUrlMushroomCountByType(), formData)
        .then(function (response) {
          var result = response.data
          // console.log(result)
          // alert(result)
          that.loading = false
          that.mushRoomByType = result
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response)
          }
        })
    },
    removeMushroom (item) {
      if (confirm('ท่านต้องการลบภาพ ใช่หรือไม่ ?')) {
        // alert(item.upload_id)
        // console.log(item.filename)
        var that = this
        const formData = new FormData()
        formData.append('upload_id', item.upload_id)
        formData.append('filename', item.filename)
        formData.append('token', this.getAuthen.token)
        this.loading = true
        axios.post(this.getUrlRemoveMushRoom(), formData)
          .then(function (response) {
            that.loading = false
            that.fetchData()
          })
          .catch(function (error) {
            alert('ผิดพลาด: ' + error.response)
          })
      }
    },
    searchByMushroomName () {
      var search = this.mushroom_search // this.$refs.mushroom_name.value
      var mushroomType = this.mushroom_type
      // alert(search)
      var that = this
      const formData = new FormData()
      formData.append('hph_id', this.getAuthen.hph_id)
      formData.append('token', this.getAuthen.token)
      formData.append('search', search)
      formData.append('mushroom_type', mushroomType)
      this.loading = true
      axios.post(this.getUrlOwnMushRoomSearch(), formData)
        .then(function (response) {
          var result = response.data
          // console.log(result)
          // alert(result)
          that.loading = false
          that.uploadedFiles = result
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response)
          }
        })
    }
  },
  computed: {
    ...mapGetters([
      'getBaseUrl',
      'getAuthen'
    ]),
    isLoading () {
      return this.loading
    },
    isSearchName () {
      return this.mushroom_search !== ''
    },
    getMushroomType () {
      var type = {
        all: 'ทั้งหมด',
        unknown: 'ไม่ทราบ',
        poison: 'เห็ดพิษ',
        edible: 'เห็ดกินได้'
      }
      return type[this.mushroom_type]
    }
  },
  components: {
    Icon
  },
  watch: {
    'mushroom_search': function (val, oldVal) {
      // alert(val.length)
      if (val.length >= 3) {
        this.searchByMushroomName()
      }
    },
    'mushroom_type': function (val, oldVal) {
      // alert(val)
      this.searchByMushroomName()
    }
  }
}
</script>



// WEBPACK FOOTER //
// OwnMushRoom.vue?402bebc2